import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingAgeGroupSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingAgeGroupSettingsEntity
